import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { CountDownPartialState } from './count-down.reducer';
import { countDownQuery } from './count-down.selectors';
import { UpdateCountDown, ClearCountDown } from './count-down.actions';

@Injectable({
  providedIn: 'root'
})
export class CountDownFacade {
  selectedCountDown$ = this.store.pipe(
    select(countDownQuery.getSelectedCountDown)
  );

  constructor(private store: Store<CountDownPartialState>) {}

  update(value: number) {
    this.store.dispatch(new UpdateCountDown(value));
  }

  clear() {
    this.store.dispatch(new ClearCountDown());
  }
}
